"use client";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import {
  File,
  Clock5,
  Server,
  Download,
  PencilLine,
  Trash2,
} from "lucide-react";

interface DocumentDetailsProps {
  activeSection?: string;
  setActiveSection?: React.Dispatch<React.SetStateAction<string>>;
}

export const DocumentDetails: React.FC<DocumentDetailsProps> = ({ }) => {
  return (
    <>
      <Card>
        <CardHeader className="border-b">
          <div className="space-y-4">
            <div className="flex flex-col lg:flex-row items-center  justify-between gap-2 ">
              <div className=" flex flex-col gap-1.5 w-full lg:w-2/3">
                <h3 className="text-foreground text-base font-medium ">
                  Client Contract Template.docs
                </h3>
                <div className="flex flex-wrap items-start gap-3">
                  <Button variant="ghost" className="h-5 p-0">
                    <File className="w-4 h-4" />
                    <span className="text-sm text-muted-foreground">
                      Word Document
                    </span>
                  </Button>
                  <Button variant="ghost" className="h-5 p-0">
                    <Clock5 className="w-4 h-4" />
                    <span className="text-sm text-muted-foreground">
                      Updated: Dec 15, 2024
                    </span>
                  </Button>
                  <Button variant="ghost" className="h-5 p-0">
                    <Server className="w-4 h-4" />
                    <span className="text-sm text-muted-foreground">
                      5.2 MB
                    </span>
                  </Button>
                </div>
              </div>

              <div className="lg:flex  space-y-3  lg:space-y-0  gap-2 w-full lg:w-80">
                <Button className="w-full lg:w-auto">
                  <Download className="w-4 h-4" />
                  Download
                </Button>

                <Button variant="outline" className="w-full lg:w-auto">
                  <PencilLine className="w-4 h-4" />
                  Edit
                </Button>

                <Button
                  variant="outline"
                  className="w-full lg:w-auto bg-red-50 border-red-300 hover:text-destructive text-destructive"
                >
                  <Trash2 className="w-4 h-4" />
                  Delete
                </Button>
              </div>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-y-4 mt-5">
          <div className="flex flex-col lg:flex-row gap-4">
            <Card className="flex-1 p-4 lg:w-96 w-full shadow-sm bg-muted">
              <div className="text-xl font-medium">Document Content Here</div>
              {/* Content goes here */}
            </Card>

            <Card className="w-full lg:w-[320px] p-3 shadow-sm bg-background">
              <div className="flex justify-between items-center p-4">
                <div className="space-y-3">
                  <Button variant="ghost" className="p-0 h-8">
                    Document Information
                  </Button>

                  <div className="space-y-2">
                    <div>
                      <p className="text-xs text-muted-foreground">Type</p>
                      <Button variant="ghost" className="p-0 h-5 font-normal">
                        Word Document
                      </Button>
                    </div>

                    <div>
                      <p className="text-xs text-muted-foreground">Size</p>
                      <Button variant="ghost" className="p-0 h-5 font-normal">
                        5.2 MB
                      </Button>
                    </div>

                    <div>
                      <p className="text-xs text-muted-foreground">Uploaded</p>
                      <Button variant="ghost" className="p-0 h-5 font-normal">
                        December 15, 2024
                      </Button>
                    </div>

                    <div>
                      <p className="text-xs text-muted-foreground">
                        Data Source
                      </p>
                      <Button variant="ghost" className="p-0 h-5">
                        Sales Scripts
                      </Button>
                    </div>

                    <div className="space-y-1">
                      <p className="text-xs text-muted-foreground">Labels</p>
                      <div className="flex gap-1 flex-wrap">
                        <Badge
                          variant="secondary"
                          className="bg-blue-100 text-blue-700"
                        >
                          Sales
                        </Badge>
                        <Badge
                          variant="secondary"
                          className="bg-purple-100 text-purple-700"
                        >
                          Report
                        </Badge>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

